import { EVENT_PRODUCT_BOX_CLICK, EVENT_PRODUCT_BOX_CLICK_DETAIL } from '~~/constants/googleTagManager';
import type { TagProductBox } from '~~/types/integrations/tagManager/TagProductBox';

export const buildClickProductBoxTags = (boxType: string, product: TagProductBox) => ({
  event: EVENT_PRODUCT_BOX_CLICK,
  event_info: {
    detail: EVENT_PRODUCT_BOX_CLICK_DETAIL,
    type: boxType,
  },
  ecommerce: { items: [product] },
});
